import React from 'react';
import { AppButton, Box, Hint, Inscription } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';

const TOOLTIP_TEXT = "You don't have permission to do this";

interface Props {
  onReviewClick: () => void;
  isWithTopBorder?: boolean;
}

const BadAddressBanner: React.FC<Props> = ({ onReviewClick, isWithTopBorder = true }) => {
  const hasEditPermission = useHasAccess([
    { permission: Permissions.EDIT_EE_DATA },
    { permission: Permissions.EDIT_PROFILE },
  ]);

  return (
    <Box
      pad="spacing24"
      background="warningContainer"
      border={{ color: 'warningBorder', size: '1px' }}
      round="container1Round"
      data-testid="bad-address-banner"
      style={{ position: 'relative' }}
    >
      {isWithTopBorder ? (
        <Box
          height="2px"
          round="small"
          background="warning"
          style={{ position: 'absolute', top: '-0.5px', left: '24px', right: '24px' }}
        />
        ) : null}
      <Box direction="row" align="center" justify="between">
        <Box gap="spacing8">
          <Inscription lineHeight="20px" weight="bold" color="textBody">
            We recently had mail returned by the postal service for this employee.
          </Inscription>
          <Inscription lineHeight="20px" color="textBody">
            Please review the address provided to ensure it is correct.
          </Inscription>
        </Box>
        <Box flex={{ shrink: 0 }}>
          {hasEditPermission ? (
            <AppButton
              testId="bad-address-banner_review-button"
              onClick={onReviewClick}
              width="210px"
            >
              Review Address
            </AppButton>
          ) : (
            <Hint
              hintElement={(
                <AppButton
                  testId="bad-address-banner_review-button-disabled"
                  disabled
                  width="auto"
                >
                  Review Address
                </AppButton>
              )}
            >
              <Inscription size="small" textAlign="center">
                {TOOLTIP_TEXT}
              </Inscription>
            </Hint>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default BadAddressBanner;
